export default {
  ERROR_MATERIAL_CREATE: 'We experienced an error while creating a new material. Please try again.',
  ERROR_MATERIAL_DELETE: 'An error occurred deleting the material. Please try again',
  ERROR_MATERIAL_NOT_FOUND: 'We couldn\'t find the requested material. Please ensure you have entered the correct URL or ensure the material still exists.',
  ERROR_MATERIAL_SAVE: 'We experienced an error while saving your material. Please try again.',
  ERROR_UPLOAD_FILETYPE_RESTRICT: 'You can only upload JPEG, PNG and SVG files',
  ERROR_UPLOAD_MAX_FILELIMIT: 'You\'ve reached the maximum number of files that can be uploaded',
  ERROR_UPLOAD_MAX_FILESIZE: 'Each file must be smaller than 10MB',
  ERROR_UPLOAD_UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
  MATERIAL_DELETE_ASK: 'Are you sure you want to delete **%%**?',
  MATERIAL_DELETE_CONFIRM: 'Deleting **%%**',
} as {
  [key: string]: string,
};
